<template>
  <div :class="['main-navbar d-flex d-md-none ', stickyTop ? 'sticky-top' : '']" >
      <navbar-toggle @toggleSidebar="handleToggleSidebar"/>


  </div>
</template>

<script>
import stickybits from "stickybits";

import NavbarSearch from "./NavbarSearch.vue";
import NavbarToggle from "./NavbarToggle.vue";

export default {
  components: {
    NavbarSearch,
    NavbarToggle
  },
  mounted() {
    stickybits(this.$el, { useStickyClasses: true });
  },
  props: {
    /**
     * Whether the main navbar should be sticky, or not.
     */
    stickyTop: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleToggleSidebar() {
      this.$emit('toggleSidebar')
    }
  }
};
</script>

<style lang="scss">
.main-navbar {
  top: 2rem !important;
  border-bottom: 2px solid transparent;
  transition: all 0.5s;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(4px);

  .dropdown-menu {
    display: block;
  }

}

.js-is-sticky {
  z-index: 100;
}
</style>
